import { render } from "./manual_verification.html?vue&type=template&id=2867ddc2&external"
import script from "./manual_verification.js?vue&type=script&lang=js&external"
export * from "./manual_verification.js?vue&type=script&lang=js&external"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__